<div style="text-transform: capitalize;">
  <ng2-slim-loading-bar></ng2-slim-loading-bar>
  <router-outlet>
    <app-spinner></app-spinner>
  </router-outlet>
</div>
